import { render, staticRenderFns } from "./analysis-of-payment.vue?vue&type=template&id=fabfb1f2&scoped=true&"
import script from "./analysis-of-payment.vue?vue&type=script&lang=ts&"
export * from "./analysis-of-payment.vue?vue&type=script&lang=ts&"
import style0 from "./analysis-of-payment.vue?vue&type=style&index=0&id=fabfb1f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabfb1f2",
  null
  
)

export default component.exports